import React from 'react';

function Copyright() {
    return <p className="text-sm">jiffyscan.xyz &copy; {new Date().getFullYear()}</p>;
}

export default Copyright;
